/**
 * Support Configuration Constants
 * Centralized configuration for support-related settings
 */

export const SUPPORT_CONFIG = {
  // Support URLs
  helpUrl: "https://docs.finitless.com/",

  // Intercom Configuration
  intercom: {
    appId: import.meta.env.VITE_INTERCOM_APP_ID || "", // Will be set via environment variable
    enabled: !!import.meta.env.VITE_INTERCOM_APP_ID, // Only enabled if app ID is provided
    // Messenger API host (EU / regional workspaces); see Intercom install docs
    apiBase:
      import.meta.env.VITE_INTERCOM_API_BASE || "https://api-iam.intercom.io",
  },

  // Canny (feedback board) — https://developers.canny.io/install
  canny: {
    appId: import.meta.env.VITE_CANNY_APP_ID || "",
    enabled: !!import.meta.env.VITE_CANNY_APP_ID,
    url: "https://finitless.canny.io/",
  },

  // Support Options
  supportOptions: [
    {
      id: "help-center",
      title: "Help Center",
      titleKey: "support.options.helpCenter.title",
      description: "Browse documentation and guides",
      descriptionKey: "support.options.helpCenter.description",
      icon: "BookOpen",
      action: "external",
      url: "https://docs.finitless.com/",
      password: "FinitlessAccess",
    },
    {
      id: "messages-tickets",
      title: "Messages & Tickets",
      titleKey: "support.options.messagesTickets.title",
      description: "Send messages and create support tickets",
      descriptionKey: "support.options.messagesTickets.description",
      icon: "MessageCircle",
      action: "intercom",
    },
    {
      id: "feature-requests",
      title: "Feature Requests & Feedback",
      titleKey: "support.options.featureRequests.title",
      description:
        "Share your ideas, report issues, and help us improve Finitless.",
      descriptionKey: "support.options.featureRequests.description",
      subtitle: "Vote on existing ideas or submit your own",
      subtitleKey: "support.options.featureRequests.subtitle",
      icon: "Lightbulb",
      action: "canny",
      url: "https://finitless.canny.io/",
      badge: "Vote features",
      badgeKey: "support.options.featureRequests.badge",
    },
  ],
};

export default SUPPORT_CONFIG;
